import { Component } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';


@Component({
    selector: 'agpr-mention-saving-limit-exceeded-dialog',
    templateUrl: './mention-saving-limit-exceeded-dialog.component.html',
    styleUrls: ['./mention-saving-limit-exceeded-dialog.component.scss'],
    standalone: false
})
export class MentionSavingLimitExceededDialogComponent extends AbstractDialogComponent {

    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'MentionSavingLimitExceededDialog');
    }

    confirm(): void {
        this.closeDialog(true);
    }

    cancel(): void {
        this.closeDialog(false);
    }
}
